'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

var defaultAllowedProtocols = ['http:', 'https:', 'mailto:', 'tel:', 'sms:'];

/**
 * Given a URL returns it if the url matches the allowed sanitization checks
 * If the sanitization checks fail, or if the url is undefined return a fallback value.
 * @param url - The URL, usually from an untrusted source
 * @param options - Options to control sanitization
 * @returns A URL or undefined. Undefined will be returned if fallback is not present, and if the url is either undefined or had issues.
 */
var useSanitizedUrl = function useSanitizedUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    fallback = _ref.fallback,
    _ref$allowedProtocols = _ref.allowedProtocols,
    allowedProtocols = _ref$allowedProtocols === void 0 ? defaultAllowedProtocols : _ref$allowedProtocols,
    allowedHosts = _ref.allowedHosts;
  // Use memo so we don't re-parse URLS on every render when they're
  // likely static.
  var parsed = React.useMemo(function () {
    if (url != null) {
      if (typeof document === 'undefined') {
        return url;
      }
      // use document.baseURI to correctly handle relative urls
      var urlObj = new URL(url, document.baseURI);
      if (allowedProtocols.includes(urlObj.protocol)) {
        if (allowedHosts == null || allowedHosts.includes(urlObj.host)) {
          return url;
        }
      }
    }
    return undefined;
  }, [url, allowedProtocols, allowedHosts]);
  return parsed !== null && parsed !== void 0 ? parsed : fallback;
};

exports.useSanitizedUrl = useSanitizedUrl;
//# sourceMappingURL=index.js.map
